import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackingComponent } from './components/tracking/tracking.component';
import { MasterTrackingComponent } from './components/master-tracking/master-tracking.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';

const routes: Routes = [
  { path: '', component: TrackingComponent },
  { path: ':id', component: MasterTrackingComponent },
  { path: 'error/404', component: ErrorPageComponent },
  // { path: '**', redirectTo: 'error' }  // Catch-all for unknown routes

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
